import i18n from 'i18next'
import i18nBackend from 'i18next-http-backend'
import { initReactI18next } from 'react-i18next'

// Import modular translations
import { enTranslations } from './translations/en'
import { krTranslations } from './translations/kr'

i18n
  .use(i18nBackend)
  .use(initReactI18next)
  .init({
    fallbackLng: localStorage.getItem('selectedLanguage') ?? 'kr',
    debug: false,
    detection: {
      order: ['cookie', 'localStorage', 'navigator'],
      caches: ['cookie'],
    },
    interpolation: {
      escapeValue: false,
    },
    resources: {
      en: {
        translation: enTranslations,
      },
      kr: {
        translation: krTranslations,
      },
    },
  })

export default i18n
